import { useMemo } from 'react';
import {
    AnyFinancialEntity,
    isDepositoryAccount,
} from '../../financialEntities';
import { useFinancialEntitiesContext } from '../financialEntities';

export interface TransactionAccounts {
    transactionAccounts: AnyFinancialEntity[] | undefined;
    loading: boolean;
}

export const useTransactionAccounts = ({
    excludeGoalAccounts = false,
}: {
    excludeGoalAccounts?: boolean;
}): TransactionAccounts => {
    const { fes } = useFinancialEntitiesContext();

    return useMemo(() => {
        return {
            transactionAccounts: fes.unfilteredData?.financialEntities
                // Include if all of the following are true:
                // - FE is not deleted
                // - FE supports transfers (i.e. goal account or depository)
                // - User is an owner of the account
                .filter(
                    (fe) =>
                        !fe.deletedAt &&
                        (fe.type === 'PlentyGoalAccount' ||
                            (isDepositoryAccount(fe) &&
                                fe.linkStatus !== 'MANUAL')) &&
                        fe.ownersIncludeMyself
                )
                .filter(
                    (fe) =>
                        !excludeGoalAccounts || fe.type !== 'PlentyGoalAccount'
                ),
            loading: fes.loading,
        };
    }, [fes.loading, fes.unfilteredData, excludeGoalAccounts]);
};
